import type { GetSuprSendUserBody } from "@nlc/shared-types";

import { useEffect, useState } from "react";

import { Switch } from "@/components/switch";

import { useUpdateCustomProperties } from "../../hooks/useUpdateCustomProperties";
import { showToast, ToastTypeEnum } from "../utils/showToast";

export function TurnOnNotifications({ user }: { user: GetSuprSendUserBody }) {
  const update = useUpdateCustomProperties();
  const [turnOn, setTurnOn] = useState(true);

  useEffect(() => {
    if (user?.properties?.turnOn) {
      setTurnOn(user?.properties?.turnOn === "true" ? true : false);
    }
  }, []);

  const handleTurnOn = async (): Promise<void> => {
    const updateTurnOn = !turnOn;

    setTurnOn(updateTurnOn);
    update.mutate({ key: "turnOn", value: updateTurnOn.toString() });
    showToast(
      `Turn ${turnOn ? "off" : "on"} notifications`,
      ToastTypeEnum.SUCCESS,
    );
  };

  return (
    <>
      <div className="flex flex-row items-center">
        <Switch isSelected={turnOn} onChange={handleTurnOn} />
        <p className="text-text-quaternary font-medium  whitespace-nowrap ml-4 mr-4">
          Notifications on
        </p>
      </div>
    </>
  );
}
